const AUTH_CONFIG_VERSION = '2026.05.14-prod-rotation-v2';
const VERSION_KEY = 'app-auth-config-version';

export function resetStaleAuthStorage(): void {
  try {
    if (localStorage.getItem(VERSION_KEY) === AUTH_CONFIG_VERSION) return;

    const prefixes = ['okta-', 'pkce-'];
    [localStorage, sessionStorage].forEach(store => {
      Object.keys(store)
        .filter(key => prefixes.some(prefix => key.startsWith(prefix)))
        .forEach(key => store.removeItem(key));
    });
    localStorage.setItem(VERSION_KEY, AUTH_CONFIG_VERSION);
  } catch (err) {
    console.warn('Auth storage reset skipped:', err);
  }
}
